<template>
  <div class="allWrap mt-5">
  <div class="wrap" v-if="!payMethod">
      <h4 class="tit1"><span class="text-danger">測試</span>收銀臺</h4>
      <div class="row flex-wrap">
        <div class="col-lg-3 col-12 text-left">
          <span class="text-white">商品名稱： {{pay_product_name}}</span>
          <p class="text-danger mt-2 dangerText" v-if="method">支付方式如需實名驗證，請填寫正確姓名，非正確姓名無法上分，恕不負責</p>
        </div>
        <div class="col-lg-3 col-6" v-if="method">
          <div class="noIcon w-100">
            <div class="wallet_name">
              <input type="text" placeholder="真實姓名" v-model="user_name" />
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-6">
          <div class="noIcon w-100">
            <div class="wallet_name">
              <input type="text" placeholder="訂單金額" v-model="amount_total" />
            </div>
          </div>
        </div>
      </div>
      <h4 class="tit1">選填欄位(依通道需求填入)</h4>
      <div class="row flex-wrap">
        <div class="col-lg-3 col-6">
          <div class="noIcon w-100">
            <div class="wallet_name">
              <input type="text" placeholder="指定銀行" v-model="bank_id" />
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-6">
          <div class="noIcon w-100">
            <div class="wallet_name">
              <input type="text" placeholder="末端商戶號" v-model="member_id" />
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-6">
          <div class="noIcon w-100">
            <div class="wallet_name">
              <input type="text" placeholder="附言" v-model="remark" />
            </div>
          </div>
        </div>
      </div>
      <h4 class="tit1">支付方式</h4>
      <div class="payMethod pointer d-flex flex-wrap">
        <div
          class="pay"
          :class="{'active' : pay_channel_id == list.pay_channel_id}"
          @click="pay_channel_id = list.pay_channel_id ; type=list.type"
          v-for="(list) in payChannel"
          :key="list.pay_channel_id"
        >
          <div class="left"></div>
          <div class="payContent">
            <p
              class="title text-left"
            >{{list.pay_channel_name.split('-')? list.pay_channel_name.split('-')[0] : list.pay_channel_name}}</p>
            <p>{{list.pay_channel_name.indexOf('-')!=-1 ? list.pay_channel_name.substring(list.pay_channel_name.indexOf('-')):list.pay_channel_name}}</p>
          </div>
        </div>
      </div>
      <button class="btn btn-green send" @click="send">立即支付</button>
    </div>
    <h4 class="tit1 text-center" v-else>{{msg || '訂單已建立'}}</h4>
  </div>
</template>
<style lang="scss" scoped>
.allWrap {
  justify-content: center;
}
.send {
  display: flex;
  margin: 0 auto;
  justify-content: center;
  margin-top: auto;
}

</style>
<script>
import axios from "axios";
export default {
  data() {
    return {
      pay_channel_id: "",
      pay_product_name: " Vip基礎服務",
      type: "",
      payChannel: "",
      user_name: "",
      amount_total: "",
      method: false,
      payMethod:'',
      msg:"",
      bank_id:"",
      member_id:"",
      remark:"",
    };
  },
  methods: {
    send() {
      let data = {};
      if (Object.keys(this.$route.query).indexOf("mid") != -1) {
        data = {
          amount_total: this.amount_total,
          pay_channel_id: this.pay_channel_id,
          user_name: this.user_name,
          pay_product_name: this.pay_product_name,
          type: this.type,
          bank_id: this.bank_id,
          member_id: this.member_id,
          remark: this.remark,
        };
      } else {
        data = {
          amount_total: this.amount_total,
          pay_channel_id: this.pay_channel_id,
          user_name: this.user_name,
          pay_product_name: this.pay_product_name,
          type: this.type,
          bank_id: this.bank_id,
          member_id: this.member_id,
          remark: this.remark
        };
      }
      if (
        this.$route.name == "demo_code" ||
        this.$route.name == "demo_member"
      ) {
        data = {
          amount_total: this.amount_total,
          pay_channel_id: this.pay_channel_id,
          user_name: this.user_name,
          pay_product_name: this.pay_product_name,
          type: this.type,
          bank_id: this.bank_id,
          member_id: this.member_id,
          remark: this.remark,
        };
      }
      Object.keys(data).forEach(e=>{
        if(data[e] === '') {
          delete data[e]
        }
      })
      axios
        .post(`${process.env.VUE_APP_DEFAULT_SRC}order`, data)
        .then(res => {
          if (res.data.code == 0) {
            if(res.data.data && res.data.data.message && res.data.data.message == 'Server Error') {
              this.msg = '未知錯誤,請聯繫技術'
            }
            if(res.data.data.view_url){
            window.location.href = res.data.data.view_url;
            }else{
              // res.data.data.view_url == null
              this.payMethod = 1
              axios
              .get(
                `${process.env.VUE_APP_DEFAULT_SRC}query?transaction_id=${res.data.data.transaction_id}`
              )
                .then(res => {
            if (res.data.code == 0) {

            } else {

            }
            });
            }
            } else {
              alert(res.data.message);
            }
        });
    }
  },
  created() {
    this.msg = "";
    if (Object.keys(this.$route.query).indexOf("mid") != -1) {
      this.pay_product_name = "商戶內充單";
    } else {
      this.pay_product_name = "玩家充值單";
    }
    if (Object.keys(this.$route.query).indexOf("mid") != -1) this.method = true;
    if (this.$route.name == "demo_code" || this.$route.name == "demo_member") {
      this.method = true;
    }
    if (this.$route.name == "demo_code" || this.$route.name == "demo_member") {
      this.pay_product_name = "管理員測試單";
    }
    axios
      .post(
        `${process.env.VUE_APP_DEFAULT_SRC}list`,
        this.$route.query
      )
      .then(res => {
        if (res.data.code == 0) {
          this.payChannel = res.data.data;
          this.pay_channel_id = res.data.data[0].pay_channel_id
          this.type = res.data.data[0].type
        } else {
          alert(res.data.message);
        }
      });
  },
};
</script>
